import { Box } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { InquiryResultDisplayType } from "../../assets/data/Constants";
import { labelids } from "../../assets/data/TkExplanationProperty";
import TkButton from "../../components/atoms/TkButton";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkDataTable from "../../components/molecules/TkDataTable";
import { BusinessContext } from "../../context/businessContext";
import { GlobalContext } from "../../context/globalContext";
import "./_style.scss";
import { funInfoBodyList } from "./hooks/useHooks";
import { headTitleList } from "./parts";
import { IAPI_INQ001_Request } from "../../type/apiType";
import { httpAPI_INQ001 } from "./api/request";

/**
 * SCRW120002 検索該当一覧
 * @return SCRW120002 検索該当一覧
 */
const SCRW120002 = () => {
  const navigate = useNavigate();
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState, setState: setBusinessState } =
    useContext(BusinessContext);
  const [bodyListData, setBodyListData] = useState<any>([]);
  const [reqData, setReqData] = useState<IAPI_INQ001_Request>({});

  //リンク 押下
  const handleLink = (path: string, state: {}) => {
    setBusinessState({
      ...businessState,
      job_114: { ...businessState.job_114, ...state },
    });

    navigate(path);
  };

  //詳細 ボタン 押下
  const handBtn = async (
    contractorNo: string,
    resultType: InquiryResultDisplayType,
    facilityNo?: string,
    detailDisplayCd?: string
  ) => {
    setBusinessState({
      ...businessState,
      job_114: {
        ...businessState.job_114,
        searchContractorNo: contractorNo,
        searchFacilityNo: facilityNo,
        searchResultDisplayTarget: resultType,
      },
    });
    //リクエストデータを更新する
    let reqDataNew: IAPI_INQ001_Request = {
      ...reqData,
      contractorNo,
      facilityNo,
      detailDisplayCd,
    };

    // 検索該当一覧参照API 呼び出し
    try {
      const res = await httpAPI_INQ001({
        ...reqDataNew,
      });
      if (res.resultCd === "I0000") {
        setBodyListData(
          funInfoBodyList(
            res.searchResultList!,
            handleLink,
            handBtn,
            resultType
          )
        );
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  //初期化
  const handleInit = async () => {
    //リクエストデータを作成する
    let reqData: IAPI_INQ001_Request = {
      contractorNo: businessState.job_114?.searchContractorNo,
      contractorAddress: businessState.job_114?.contractorAddress,
      corpNameKana: businessState.job_114?.corpNameKana,
      corpName: businessState.job_114?.corpName,
      tel: businessState.job_114?.tel,
      fax: businessState.job_114?.fax,
      facilityNo: businessState.job_114?.searchFacilityNo,
      facilityAddress: businessState.job_114?.facilityAddress,
      facilityName: businessState.job_114?.facilityName,
      bReformJoinFlg: businessState.job_114?.bReformJoinFlg,
      aReformJoinFlg: businessState.job_114?.aReformJoinFlg,
      facilityKbn1: businessState.job_114?.facilityKbn1,
      facilityKbn2: businessState.job_114?.facilityKbn2,
      staffNo: businessState.job_114?.searchStaffNo,
      staffNameKanji: businessState.job_114?.staffNameKanji,
      birthday: businessState.job_114?.birthday,
      joinStatus1: businessState.job_114?.joinStatus1,
      joinStatus2: businessState.job_114?.joinStatus2,
      joinDate:
        businessState.job_114?.joinStatus1 === "6"
          ? businessState.job_114?.joinDateFrom
          : businessState.job_114?.joinStatus1 === "7"
          ? businessState.job_114?.joinDateTo
          : undefined,
      retireFlg: businessState.job_114?.retireFlg,
      detailDisplayCd: businessState.job_114?.detailDisplayCd,
    };
    Object.keys(reqData).forEach((k) => {
      let key = k as keyof typeof reqData;
      if (!reqData[key]) delete reqData[key];
    });

    const resultType: any = businessState.job_114?.searchResultDisplayTarget;

    //リクエストデータを更新する
    setReqData(reqData);
    try {
      const res = await httpAPI_INQ001({
        ...reqData,
      });
      if (res.resultCd === "I0000") {
        setBodyListData(
          funInfoBodyList(
            res.searchResultList!,
            handleLink,
            handBtn,
            resultType
          )
        );
        setState({
          ...state,
          errorMsgId: "",
        });
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="SCRW120002" data-testid="SCRW120002PageForTest">
      <Box>
        <TkDataTable
          bodyList={bodyListData}
          count={bodyListData.length}
          defaultRowsPerPage={5}
          headList={headTitleList}
          headerLeftComponent={bodyListData.length + " 件ヒットしました。"}
          pagin
        />
      </Box>
      <Box className="LBLW120002InfoManual">
        {/* TkInfoManualを表示 */}
        <TkInfoManual rule={"\\n"}>
          {labelids.labelid.LBLW120002_01}
        </TkInfoManual>
      </Box>
      <Box className="tkBottonBox">
        <TkBackButton></TkBackButton>
        <TkButton
          onClick={() => {
            navigate("/SCRW120001");
          }}
          type="button"
          data-testid="TkButton"
          className="tkBottonMl"
        >
          {"検索画面へ"}
        </TkButton>
      </Box>
    </Box>
  );
};

export default SCRW120002;
